import { render, staticRenderFns } from "./ProductComponentCreate.vue?vue&type=template&id=5a21f784&"
import script from "./ProductComponentCreate.vue?vue&type=script&lang=ts&"
export * from "./ProductComponentCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports